var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 27",
    style: {
      enableBackground: "new 0 0 27 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F05123;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.2,2.2c-1.8,1.8-1.8,7.4,0,9c1.3,1,2.9,1.4,4.5,1.3c1.6,0.1,3.2-0.4,4.5-1.3c1.8-1.8,1.8-7.4,0-9 S4,0.4,2.2,2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.2,15.8c-1.8,1.8-1.8,7.4,0,9c1.3,1,2.9,1.4,4.5,1.3c1.6,0.1,3.2-0.4,4.5-1.3c1.8-1.8,1.8-7.4,0-9 C9.6,14,4,14,2.2,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.3,12.6c1.6,0.1,3.2-0.4,4.5-1.3c1.8-1.8,1.8-7.4,0-9c-1.8-1.7-7.4-1.8-9,0s-1.8,7.4,0,9 C17,12.2,18.6,12.7,20.3,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.8,15.8c-1.8,1.8-1.8,7.4,0,9c1.3,1,2.9,1.4,4.5,1.3c1.6,0.1,3.2-0.4,4.5-1.3c1.8-1.8,1.8-7.4,0-9 C23,14,17.4,14,15.8,15.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSelectIcon);
export default __webpack_public_path__ + "static/media/homeSelectIcon.85ef0c237b3f40b248bf4d30420f9e23.svg";
export { ForwardRef as ReactComponent };